import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

import { getDefaultHomePathForRoles } from "../../../Routes/roleAccess";

const Forbidden403 = () => {
  const { t } = useTranslation();
  const homePath = getDefaultHomePathForRoles();

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={6} className="text-center py-5">
            <h1 className="display-1 fw-medium">403</h1>
            <h4 className="text-uppercase">{t("errors.403.title")}</h4>
            <p className="text-muted mb-4">{t("errors.403.description")}</p>
            <Link to={homePath} className="btn btn-primary">
              <i className="ri-home-4-line me-1" />
              {t("errors.403.backToHome")}
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Forbidden403;
